import React from 'react';
import {
    AppBar,
    Grid,
    List,
    Typography,
    Dialog,
    Toolbar,
    ListSubheader,
    Avatar,
    ButtonBase,
    Tabs,
    Tab,
    Snackbar,
} from '@material-ui/core';

import {
    MovieChat,
    MovieAnchor,
    MovieIndex,
    MovieIntelligence,
    MovieLive,
    MovieTeamBasketball,
    MovieTeamFootball,
    MovieStateFootball,
    MovieAnalyseBasketBall,
    MovieAnalyseFootBall
} from './view';

import { withRouter, } from "react-router-dom"
import { withStyles } from '@material-ui/core/styles';
import Player from './Player';
import 'video.js/dist/video-js.min.css';
import MBackIcon from '../view/MBackIcon';
import Apis from '../../network/Apis';
import MTabPanel from '../view/MTabPanel'
import MovieStateBasket from './view/MovieStateBasket';
import Live from '../../model/Live';
import MatchType from '../../model/MatchType';
import Match from '../../model/Match';
import DateUtils from '../../control/dateutils';
import Swiper from 'react-id-swiper';
import AppData from '../../model/AppData';
import MStatusBar from '../view/MStatusBar';
import AppUtils from '../../control/apputlis';
import MEnvelope from '../view/MEnvelope';
import Download from './view/Download';
import TabIndicator from '../view/TabIndicator';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import MySnackbarContentWrapper from '../../component/mysnackbar';

const BACK_BASKETBALL = require("../../images/bg/img_background_basketball.jpg");
const BACK_FOOTBALL = require("../../images/bg/img_background_football.jpg");
const ICON_SC = require("../../images/icons/shoucang.png");
const ICON_SCStar = require("../../images/icons/shoucang_1.png");

const ICON_FX = require("../../images/icons/fenxiang.png");
const ICON_VS = require("../../images/icons/VS.png");
const ICON_VS1 = require("../../images/icons/VS1.png");
const ICON_JUBAO = require("../../images/icons/jubao.png");
const ICON_LOGO = require("../../images/change/logo_title.png");


const ICON_PRIVATE = require("../../images/icons/icon_private.png");
const ICON_COPY = require("../../images/icons/icon_copy.png");
const ICON_SHARE = require("../../images/icons/icon_share.png");
const ICON_ROUTER = require("../../images/icons/ic_change_router.png");

class MoviePlayerPage extends React.Component {

    constructor(props) {
        super(props);
        this.player = null;
        let params = props.match.params;
        this.matchType = 0;
        this.matchId = 0;
        this.roomId = 0;
        if (params.matchType != 0 && params.matchType != undefined && params.matchType != 'undefined') {
            this.matchType = params.matchType;
        }
        if (params.matchId != 0 && params.matchId != undefined && params.matchId != 'undefined') {
            this.matchId = params.matchId;
        }
        if (params.room_id != 0 && params.room_id != undefined && params.room_id != 'undefined') {
            this.roomId = params.room_id;
        }

        let isStar = AppData.isStarMatch(this.matchType, this.matchId);

        let data = props.location.data;
        if (data) {
            AppUtils.setStorageObj('MOVIE_PLAYER_LOACATION_DATA', props.location.data);
        } else {
            data = AppUtils.getStorageObj('MOVIE_PLAYER_LOACATION_DATA');
        }

        this.state = {
            data: data,
            opened: true,
            value: 0,
            matchData: null,
            roomData: null,
            liveSource: null,
            param: data,
            TabTexts: [],
            bannerDatas: [],
            isStar: isStar,
            isStarAnchor: false,
            showDownload: false,
            qrcode: '',
            copy_content: '',
            liveUrl: '',
            liveUrlData: '',
            liveUrlList: [],
            liveUrlIndex: 0,
        };

        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 0,
        };

        console.log('MoviePlayerPage', props);
    }

    componentDidMount() {
        this._requestDatas();
        this.getBanners();
        this.watchLive('in');
        this.encryptionLiveLog();
        this.encryptionQrcode();
        AppUtils.YMPush('MAIN', 'MoviePlayerPage');
        // this.jumplanuch = setInterval(() => {
        //     if (!this.state.showDownload) {
        //         this.setState({ showDownload: true });
        //     }
        // }, 60 * 1000 * 2);
    }

    componentWillUnmount() {
        // this.jumplanuch && clearInterval(this.jumplanuch);
        this.setState = () => false;
        this.watchLive('out');
    }

    _onCloseDownload = () => {
        this.setState({ showDownload: false });
    }

    encryptionLiveLog = async () => {
        if (this.roomId) {
            let user_id = AppData.me.getUid();
            Apis.encryptionLiveLog(user_id, AppData.me.isLogin() ? 2 : 1, this.roomId);
        }
    }

    encryptionQrcode = async () => {
        console.log('encryptionQrcode', this.roomId);
        if (this.roomId) {
            let res = await Apis.encryptionQrcode(this.roomId);
            console.log('encryptionQrcode', res);
            if (res.code == 200 && res.data && res.data.qrcode) {
                this.setState({ qrcode: res.data.qrcode });
            }
        }
    }

    watchLive = async (type) => {
        if (AppData.me.isLogin()) {
            let user_id = AppData.me.getUid();
            Apis.encryptionCustomerInLive(user_id, type);
        }
    }

    setMovie = (is_has_chat) => {
        if (this.roomId == 0 && this.matchType == 0 && this.matchId == 0) {
            let TabTexts = [];
            // if (is_has_chat == 1) {
            //     TabTexts.push('聊天');
            // }
            TabTexts.push('直播');
            this.setState({ TabTexts: TabTexts })
        }
    }


    _requestDatas = async () => {
        let is_has_history = 1;
        let is_has_intelligence = 1;
        let is_has_analysis = 1;
        let is_has_chat = 1;

        if (!AppData.ServerConfig) {
            let res = await Apis.encryptionServerConfig();
            console.log("encryptionServerConfig", res);
            if (res.code == 200 && res.data) {
                AppData.ServerConfig = res.data;
            }
        }

        is_has_history = AppData.ServerConfig.is_has_history;
        is_has_intelligence = AppData.ServerConfig.is_has_intelligence;
        is_has_analysis = AppData.ServerConfig.is_has_analysis;
        is_has_chat = AppData.ServerConfig.is_has_chat;


        if (AppData.IsCloseChat) {
            is_has_chat = 2;
        }

        if (this.roomId != 0) {
            let result = await Apis.encryptionHostInfo(this.roomId);
            console.log('_requestDatas', result);
            if (result.code == 200) {
                this.state.copy_content = result.data.copy_content;
                if (result.data.match_id != 0) {
                    this.matchId = result.data.match_id;
                }
                if (result.data.matchType != 0) {
                    this.matchType = result.data.type_id;
                }
                this.getMatch(is_has_history, is_has_intelligence, is_has_analysis, is_has_chat);
                this.getLiveSource();
                this.setRoomInfo(result.data, is_has_history, is_has_intelligence, is_has_analysis, is_has_chat);
            }
        } else {
            this.getMatch(is_has_history, is_has_intelligence, is_has_analysis, is_has_chat);
            this.getLiveSource();
        }
    }

    getBanners = async () => {
        let result = await Apis.encryptionBanner();
        if (result.code == 200) {
            this.setState({ bannerDatas: result.data });
        }
    }

    getMatch = async (is_has_history, is_has_intelligence, is_has_analysis, is_has_chat) => {
        if (this.matchType && this.matchId) {
            let result = await Apis.encryptionMatchDetail(this.matchType, this.matchId);
            console.log('getMatch', result);
            if (result.code == 200) {
                if (this.roomId > 0) {
                    this.setState({ matchData: result.data });
                } else {
                    this.setMatch(result.data, is_has_history, is_has_intelligence, is_has_analysis, is_has_chat);
                }
            }
        } else {
            this.setMovie(is_has_chat);
        }
    }

    _onSnackClosed() {
        this.setState({
            snackopened: false,
        });
    }

    _onClickStar = () => {
        let isStar = !this.state.isStar;
        if (isStar) {
            this.starMatch();
        } else {
            this.unStarMatch();
        }
        console.log('_onClickStar', isStar);
        this.setState({ isStar: isStar });
    }

    _onClickShare = () => {
        console.log('_onClickShare');
    }

    _onClickJubao = () => {
        this.props.history.push({ pathname: '/accusation/' + this.roomId });
    }

    starMatch = async () => {
        let ids = [];
        ids.push(this.matchId + '_' + this.matchType);
        let result = await Apis.encryptionFocusEvent(JSON.stringify(ids));
        console.log('starMatch', result);
        if (result.code == 200 && result.data) {
            AppData.getStarMatch(this.matchType);
        }
    }

    unStarMatch = async () => {
        let ids = [];
        ids.push(this.matchId + '_' + this.matchType);
        let result = await Apis.encryptionFocusEvent(JSON.stringify(ids), 1);
        console.log('unStarMatch', result);
        if (result.code == 200 && result.data) {
            AppData.getStarMatch(this.matchType);
        }
    }


    getLiveSource = async () => {
        if (this.matchType && this.matchId) {
            let result = await Apis.encryptionHostMatch(this.matchType, this.matchId);
            console.log('getLiveSource', result);
            if (result.code == 200) {
                this.state.liveSource = result.data;
                let liveUrl = this._getLiveSource();
                this.setState({ liveSource: result.data, liveUrl });
            }
        }
    }

    _onClickStarAnchor = () => {
        if (!AppData.me.isLogin()) {
            this.props.history.push('/login');
            return;
        }

        let isStarAnchor = !this.state.isStarAnchor;
        this.setState({ isStarAnchor: isStarAnchor });
        if (isStarAnchor) {
            this.starAnchor();
        } else {
            this.unStarAnchor();
        }
    }

    starAnchor = async () => {
        let result = await Apis.encryptionFocusHost(JSON.stringify([this.props.data.user_id]));
        console.log('starAnchor', result);
        if (result.code == 200) {
            if (result.data) {
                AppData.getStarAnchor();
            }
        }
    }

    unStarAnchor = async () => {
        let result = await Apis.encryptionFocusHost(this.props.data.user_id, 1);
        console.log('unStarAnchor', result);
        if (result.code == 200) {
            if (result.data) {
                AppData.getStarAnchor();
            }
        }
    }

    setMatch(data, is_has_history, is_has_intelligence, is_has_analysis, is_has_chat) {
        let TabTexts = [];
        let match = new Match(data);
        let num = 3;
        if (match.living()) {
            // if (is_has_chat == 1) {
            //     TabTexts.push('聊天');
            //     num++;
            // }
            TabTexts.push('赛况');
        } else {
            TabTexts.push('赛况');
            // if (is_has_chat == 1) {
            //     TabTexts.push('聊天');
            //     num++;
            // }
        }
        if (is_has_intelligence == 1) {
            TabTexts.push('分析');
            num++;
        }
        if (is_has_history == 1) {
            TabTexts.push('指数');
            num++;
        }
        TabTexts.push('阵容');
        if (is_has_analysis == 1) {
            TabTexts.push('情报');
            num++;
        }
        TabTexts.push('直播');
        this.setState({ matchData: data, TabTexts: TabTexts })
    }

    setRoomInfo = (data, is_has_history, is_has_intelligence, is_has_analysis, is_has_chat) => {
        console.log('setRoomInfo', data);
        let TabTexts = [];
        if (data.live_status == Live.STATUS_LIVE && data.push_status == Live.STATUS_LIVE) {
            let num = 4;
            if (is_has_chat == 1) {
                TabTexts.push('聊天');
                num++;
            }
            TabTexts.push('主播');
            if (this.matchId) {
                TabTexts.push('赛况');
                if (is_has_intelligence == 1) {
                    TabTexts.push('分析');
                    num++;
                }
                if (is_has_history == 1) {
                    TabTexts.push('指数');
                    num++;
                }
                TabTexts.push('阵容');
                if (is_has_analysis == 1) {
                    TabTexts.push('情报');
                    num++;
                }
                TabTexts.push('直播');
                this.setState({ roomData: data, TabTexts: TabTexts })
            } else {
                this.setState({ roomData: data, TabTexts: TabTexts })
            }
        } else {
            TabTexts.push('主播');
            TabTexts.push('直播');
            this.setState({ roomData: data, TabTexts: TabTexts })
        }
    }

    _getLiveSource = () => {
        const { data, liveSource } = this.state;
        let roomId = this.roomId;
        if (roomId == 0 && data && data.room_id > 0) {
            roomId = data.room_id;
        }
        let liveUrl = '';
        let live_url_data = '';
        if (liveSource && liveSource.length > 0) {
            for (let i = liveSource.length - 1; i >= 0; i--) {
                if (roomId > 0) {
                    if (liveSource[i].room_id == roomId) {
                        liveUrl = liveSource[i].live_url;
                        live_url_data = liveSource[i].live_url_data;
                        this.state.liveUrlList = liveSource[i].live_url_list
                        this.state.liveUrlData = liveSource[i].live_url_data
                    }
                } else {
                    if (liveSource[i].live_url && liveSource[i].push_status == Live.STATUS_LIVE) {
                        liveUrl = liveSource[i].live_url;
                        live_url_data = liveSource[i].live_url_data;
                        this.state.liveUrlList = liveSource[i].live_url_list
                        this.state.liveUrlData = liveSource[i].live_url_data
                    }
                }
            }
        }
        if (data && data.live_url && data.live_url.length > 0) {
            liveUrl = data.live_url;
        }

        if (liveUrl && liveUrl != '') {
            if (liveUrl.startsWith('rtmp://')) {
                liveUrl = liveUrl.replace('rtmp://', 'https://');
                liveUrl = liveUrl + '.m3u8' + live_url_data;
            }
        }
        console.log('_getLiveSource', liveUrl);
        return liveUrl;
    }

    _onRefresh() {
        this.setState({ refreshing: true })
        this._requestDatas();
    }

    _handleChange = (val) => {
        console.log('_handleChange', val);
        if (this.state.value != val) {
            this.setState({ value: val })
        }
    }

    _showAlert = () => {

    }

    _handleTimeOut = () => {
    }

    _onPlayerReady = () => {

    }


    _playValid = () => {

    }

    onCopy = () => {
        this.setState({ snackopened: true, snackmessage: '复制成功,快去添加吧' })
    }

    onPrivateClick = () => {
        this.setState({ snackopened: true, snackmessage: '复制成功,快去添加吧' })
        // const { roomData } = this.state;
        // this.props.history.push({ pathname: '/privateletter/' + roomData.user_id + '/userProfile', data: roomData.nickname });
    }


    _renderAnchor() {
        const { classes } = this.props;
        const { param, bannerDatas } = this.state;
        return (
            <Grid container alignItems='center' direction='column' style={{ backgroundColor: '#000' }} >
                <MStatusBar />
                <Grid container alignItems='center' style={{
                    width: '100vw',
                    height: '56vw',
                    backgroundSize: '100% 100%',
                }}>
                    {
                        bannerDatas && bannerDatas.length > 0 && <Swiper {...this.params} >
                            <Grid container justify='center' alignItems='center' direction='column' style={{ width: '64vw', height: '36vw', paddingTop: 16 }}>
                                <Grid container justify='center' alignItems='center' direction='column' style={{ width: '56vw', height: '32vw', backgroundColor: '#343138', borderRadius: 10 }}>
                                    <Avatar src={param ? param.portrait : ''} className={classes.avatar} style={{ position: 'absolute', top: 0 }}></Avatar>
                                    <Typography style={{ fontSize: 12, color: '#FFFFFF' }}>主播暂不在播哦</Typography>
                                    <Typography style={{ fontSize: 12, color: '#878787' }}>关注主播可收到开播提醒</Typography>
                                </Grid>
                            </Grid>
                            {
                                bannerDatas.map((item, i) => (
                                    <Grid key={i} container justify='center' alignItems='center' direction='column' style={{ width: '64vw', height: '36vw', paddingTop: 16 }}>
                                        <img key={i} src={item.cover} className={classes.bannerImg} alt='banner'></img>
                                    </Grid>
                                ))
                            }
                        </Swiper>
                    }
                </Grid>
            </Grid>
        );
    }

    _renderMatch() {
        const { param, matchData } = this.state;
        let backgroud = param && param.room_cover ? param.room_cover : BACK_BASKETBALL;
        let homeName = '';
        let awayName = '';
        let leagueName = '';
        let status = '';
        let homeScore = '';
        let awayScore = '';
        let time = '';
        let homeLog = '';
        let away_log = '';
        let vs = ICON_VS;

        if (param) {
            let match = new Match(param);
            homeName = param.home_name ? param.home_name : '';
            awayName = param.away_name ? param.away_name : '';
            leagueName = param.short_name_zh ? param.short_name_zh : '';
            if (param.type_id == MatchType.BASKETBALL) {
                backgroud = BACK_BASKETBALL;
            } else {
                backgroud = BACK_FOOTBALL;
            }
            homeScore = match.getHomeScore();
            awayScore = match.getAwayScore();

            time = param.match_time ? DateUtils.dateFormat(param.match_time) : '';
            status = match.getStatus();
            homeLog = param.home_log;
            away_log = param.away_log;
            if (match.showScore()) {
                vs = ICON_VS;
            } else {
                vs = ICON_VS1;
            }

        }

        if (matchData) {
            let match = new Match(matchData);
            homeName = matchData.home_name;
            awayName = matchData.away_name;
            leagueName = matchData.short_name_zh;
            if (matchData.type_id == MatchType.BASKETBALL) {
                backgroud = BACK_BASKETBALL;
            } else {
                backgroud = BACK_FOOTBALL;
            }
            homeScore = match.getHomeScore();
            awayScore = match.getAwayScore();
            time = DateUtils.dateFormat(matchData.match_time);
            status = match.getStatus();
            homeLog = matchData.home_log;
            away_log = matchData.away_log;
            if (match.showScore()) {
                vs = ICON_VS;
            } else {
                vs = ICON_VS1;
            }
        }

        return (
            <Grid container alignItems='center' style={{
                backgroundSize: 'cover',
                backgroundImage: `url(${backgroud})`,
                backgroundRepeat: 'no-repeat',
                width: '100vw',
                height: '56vw',
            }}>
                <MStatusBar />
                <Grid container justify='center' direction='column' style={{ width: '100%' }}>
                    <Grid container justify='center' direction='column' style={{ textAlign: 'center' }}>
                        <Typography style={{ fontSize: 10, color: '#FFFFFF' }}>{leagueName}</Typography>
                        <Typography style={{ fontSize: 10, color: '#FFFFFF', marginTop: 4 }}>{time}</Typography>
                    </Grid>
                    <Grid container justify='center' direction='column' style={{ textAlign: 'center', marginTop: 24 }}>
                        <Typography style={{ fontSize: 10, color: '#FFFFFF' }}>{status}</Typography>
                        <Grid container justify='center' alignItems='center' direction='row'>
                            <Grid container alignItems='center' direction='column' style={{ maxWidth: '30vw' }}>
                                <img src={homeLog} style={{ width: 30, height: 30, objectFit: 'scale-down' }} />
                                <Typography style={{ fontSize: 12, color: '#FFFFFF', marginTop: 4 }}>{homeName}</Typography>
                            </Grid>
                            <Grid container alignItems='center' direction='row' style={{ flex: 1 }} >
                                <Grid container alignItems='center' direction='row' justify='flex-end' style={{ flex: 1 }}>
                                    <Typography style={{ fontSize: 30, color: '#FFFFFF', maxWidth: 48, marginRight: 8 }}>{homeScore}</Typography>
                                </Grid>
                                <img src={vs} style={{ width: 30, height: 30, objectFit: 'scale-down' }} />
                                <Grid container alignItems='center' direction='row' justify='flex-start' style={{ flex: 1 }}>
                                    <Typography style={{ fontSize: 30, color: '#FFFFFF', maxWidth: 48, marginLeft: 8 }}>{awayScore}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container alignItems='center' direction='column' style={{ maxWidth: '30vw' }}>
                                <img src={away_log} style={{ width: 30, height: 30, objectFit: 'scale-down' }} />
                                <Typography style={{ fontSize: 12, color: '#FFFFFF', marginTop: 4 }}>{awayName}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    _createChildren = (item, i, value, data) => {
        let tdata = { match_type: this.matchType, match_id: this.matchId, room_id: this.roomId, groupId: data.groupId }
        Object.assign(data, tdata);
        if (item == '聊天') {
            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieChat data={data} /> </MTabPanel>);
        } else if (item == '主播') {
            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieAnchor data={data} /> </MTabPanel>);
        } else if (item == '赛况') {
            if (this.matchType == MatchType.BASKETBALL) {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieStateBasket data={data} /></MTabPanel>);
            } else {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieStateFootball data={data} /></MTabPanel>);
            }
        } else if (item == '分析') {
            if (this.matchType == MatchType.BASKETBALL) {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieAnalyseBasketBall data={data} /></MTabPanel>);
            } else {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieAnalyseFootBall data={data} /></MTabPanel>);
            }
        } else if (item == '指数') {
            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieIndex data={data} /></MTabPanel>);
        } else if (item == '阵容') {
            if (this.matchType == MatchType.BASKETBALL) {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieTeamBasketball data={data} /></MTabPanel>);
            } else {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieTeamFootball data={data} /></MTabPanel>);
            }
        } else if (item == '情报') {
            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieIntelligence data={data} /></MTabPanel>);
        } else if (item == '直播') {
            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieLive data={data} /></MTabPanel>);
        }
    }

    _renderNoLiving() {
        if (this.roomId > 0) {
            return this._renderAnchor();
        }
        return this._renderMatch();
    }

    onChangeRouter = () => {
        let { liveUrlList, liveUrlIndex, liveUrlData, liveUrl } = this.state;
        console.log("liveUrlData==>", liveUrlData);
        if (liveUrlList.length == 0) {
            return
        }
        let idx = liveUrlIndex % liveUrlList.length;
        let url = liveUrlList[idx];
        if (url && url != '') {
            if (url.startsWith('rtmp://')) {
                url = url.replace('rtmp://', 'https://');
                url = url + '.m3u8' + liveUrlData;
            }
        }
        if (url == liveUrl) {
            this.state.liveUrlIndex++
            this.onChangeRouter()
            return
        }
        this.state.liveUrlIndex++
        if (this.state.liveUrlIndex >= liveUrlList.length) {
            this.state.liveUrlIndex = 0
        }
        console.log("liveUrl==>", url);
        this.setState({ liveUrl: url }, () => {
            if (this.player) {
                this.player.setSrc(url)
            }
        })
    }

    render() {
        const { classes } = this.props;
        let {
            opened,
            value,
            matchData,
            roomData,
            TabTexts,
            isStar,
            isStarAnchor,
            showDownload,
            qrcode,
            copy_content,
            snackopened,
            snackmessage,
            liveUrl,
            data
        } = this.state;

        let isLiving = false;
        if (roomData && this.roomId > 0) {
            if (roomData.live_status == Live.STATUS_LIVE && roomData.push_status == Live.STATUS_LIVE) {
                isLiving = true;
            }
            if (!isStarAnchor) {
                isStarAnchor = AppData.isStarAnchor(roomData.user_id);
            }
        } else if (matchData) {
            let match = new Match(matchData);
            if (match.living()) {
                isLiving = true;
            }
        } else {
            // let data = null;
            if (this.props.location && this.props.location.data) {
                data = this.props.location.data;
            }
            if (data) {
                if (data.live_type == Live.TYPE_CUSTOM) {
                    isLiving = true;
                    liveUrl = data.live_url;
                }
            }
        }

        if (!liveUrl || liveUrl.length == 0) {
            isLiving = false;
        }
        console.log("=============>", liveUrl);

        let videoJsOptions = {
            autoplay: true,  //自动播放
            language: 'zh-CN',
            controls: true,  //控制条
            preload: 'auto',  //自动加载
            errorDisplay: true,  //错误展示 
            height: window.screen.height,
            userActions: { hotkeys: true },
            sources: [{ src: liveUrl, type: "application/x-mpegURL", }]
        };

        let backgroundColor = TabTexts[value] == '主播' || TabTexts[value] == '聊天' || TabTexts[value] == '赛况' ? '#F7F7F7' : '#FFF';

        return (
            <Dialog fullScreen open={opened}>
                <List className={classes.root} style={{ backgroundColor: backgroundColor }}>
                    <ListSubheader className={classes.listHeader}>
                        {
                            isLiving && <Grid container alignItems='center' justify='center' direction='column' style={{ marginTop: 12, marginBottom: 8 }}>
                                <MStatusBar />
                                <Grid container alignItems='center' justify='center' direction='row'>
                                    {
                                        isLiving && <MBackIcon className={classes.backIcon} />
                                    }
                                    <Grid container alignItems='center' justify='center' style={{ maxWidth: 115 }}>
                                        <img src={ICON_LOGO} style={{ width: 115, height: 30 }}></img>
                                    </Grid>

                                    <Grid container alignItems='center' justify='center' style={{ maxWidth: 115, position: 'absolute', right: 16, zIndex: 100000 }}  >
                                        <ButtonBase onClick={() => this.onChangeRouter()} >
                                            <img src={ICON_ROUTER} style={{ width: 84, height: 30 }}></img>
                                        </ButtonBase>
                                    </Grid>

                                </Grid>
                            </Grid>
                        }
                        {
                            isLiving ? <Player
                                ref={(player) => this.player = player}
                                {...videoJsOptions}
                                className={classes.player}
                                callTime={5 * 60}
                                callTimeBack={() => this._handleTimeOut()}
                                playValid={() => this._playValid()}
                                onPlayerReady={() => this._onPlayerReady()}
                            >
                            </Player>

                                : this._renderNoLiving()
                        }
                        <AppBar className={classes.header}>
                            <MStatusBar />
                            <Toolbar style={{ justifyContent: 'center', alignItems: 'center' }}>
                                {
                                    !isLiving && <MBackIcon className={classes.backIcon1} />
                                }
                                {
                                    !isLiving && <Grid style={{ position: 'absolute', right: 0 }}>
                                        {
                                            this.matchType > 0 && this.matchId > 0 && <ButtonBase className={classes.iconButton} disableRipple onClick={() => this._onClickStar()}>
                                                <img src={isStar ? ICON_SCStar : ICON_SC} style={{ width: 19, height: 19, marginRight: 16 }} />
                                            </ButtonBase>
                                        }
                                        {
                                            this.roomId > 0 && isLiving && <ButtonBase className={classes.iconButton} disableRipple onClick={() => this._onClickJubao()}>
                                                <img src={ICON_JUBAO} style={{ width: 19, height: 19, marginRight: 16 }} />
                                            </ButtonBase>
                                        }
                                        <ButtonBase className={classes.iconButton} disableRipple onClick={() => this._onClickShare()}>
                                            <img src={ICON_FX} style={{ width: 19, height: 19, marginRight: 16 }} />
                                        </ButtonBase>
                                    </Grid>
                                }
                            </Toolbar>
                        </AppBar>
                        <Grid container justify='center' alignItems='center' direction='column'>
                            <Grid container alignItems='center' justify='center' style={{ backgroundColor: '#FFF', width: '100%' }}>
                                {
                                    TabTexts.length != 0 && <Tabs
                                        value={value}
                                        variant='fullWidth'
                                        onChange={(e, val) => this._handleChange(val)}
                                        TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                                        style={{ minHeight: 32, width: '100vw' }}
                                    >
                                        {
                                            TabTexts.map((item, i) => (
                                                <Tab key={i} label={item} style={{ color: value == i ? '#0D0D0D' : '#878787', fontSize: 14, padding: 0, minHeight: 32, minWidth: 48 }}></Tab>
                                            ))
                                        }
                                    </Tabs>
                                }
                            </Grid>
                            <Grid style={{ height: 1, backgroundColor: '#F7F7F7', width: '100%' }}></Grid>
                        </Grid>
                    </ListSubheader>
                    {
                        <Grid container direction='column' style={{ width: '100vw' }}>
                            {
                                TabTexts.map((item, i) => (
                                    this._createChildren(item, i, value, Object.assign(matchData ? matchData : {}, roomData))
                                ))
                            }
                        </Grid>
                    }
                    <MEnvelope />
                    {
                        qrcode && qrcode.length > 0 && <img src={qrcode} className={classes.qrcode}></img>
                    }
                </List>
                {
                    TabTexts[value] == '聊天' && <Grid container alignItems='center' direction='column' className={classes.copyButtonGrid}>
                        {
                            copy_content && copy_content.length > 0 && <CopyToClipboard text={copy_content} onCopy={this.onCopy}>
                                <ButtonBase className={classes.copyButton} onClick={() => this.onCopy()}>
                                    <img src={ICON_COPY} style={{ width: 38, height: 29 }}></img>
                                </ButtonBase>
                            </CopyToClipboard>
                        }
                        {
                            AppData.ShareUrl && AppData.ShareUrl.length > 0 && <CopyToClipboard text={AppData.ShareUrl} onCopy={this.onCopy}>
                                <ButtonBase className={classes.copyButton} onClick={() => this.onPrivateClick()} style={{ marginTop: 56 }}>
                                    <img src={ICON_SHARE} style={{ width: 38, height: 38 }}></img>
                                </ButtonBase>
                            </CopyToClipboard>
                        }
                    </Grid>
                }
                {
                    showDownload && <Download onClose={() => this._onCloseDownload()} />
                }

                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this._onSnackClosed()}
                    autoHideDuration={2000}
                >
                    <MySnackbarContentWrapper
                        className={classes.snackbar}
                        message={snackmessage}
                        variant='info'
                    />
                </Snackbar>
            </Dialog >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: 0,
        backgroundColor: '#FFF'
    },
    player: {
        width: '100%',
        height: 'auto',
        position: 'absolute',
        zIndex: 0,
    },
    header: {
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'absolute',
        boxShadow: 'none',
    },
    backIcon: {
        color: '#0D0D0D',
        zIndex: 10001,
    },
    backIcon1: {
        color: '#FFF',
    },
    listHeader: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
    },
    bannerImg: {
        width: "56vw",
        height: "32vw",
        objectFit: 'cover',
        borderRadius: 10,
        marginLeft: 8,
    },
    avatar: {
        width: 50,
        height: 50,
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
    },
    snackbar: {
        marginTop: '45vh',
    },
    dyButton: {
        minWidth: 50,
        backgroundColor: '#FC3035',
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: '#FFF',
        fontSize: 12,
        position: 'absolute',
        right: 0
    },
    dy1Button: {
        minWidth: 50,
        backgroundColor: '#FFF',
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: '#878787',
        fontSize: 12,
        position: 'absolute',
        right: 0
    },
    qrcode: {
        width: '25vw',
        height: '25vw',
        position: 'fixed',
        right: 8,
        borderRadius: 8,
        bottom: '25vh'
    },
    copyButtonGrid: {
        // zIndex: 1100001,
        maxWidth: 38,
        position: 'absolute',
        right: 16,
        top: '45vh',

    },
    copyButton: {
        color: '#FFF',
        fontSize: 12,
        width: 38,
        height: 29,
        borderRadius: 12,
        marginLeft: 8,
        marginTop: 16,
    }
}))(MoviePlayerPage));